import { ThemeUIStyleObject } from '@apia/theme';
import fields from './fields';
import header from './header';

const charts: ThemeUIStyleObject = {
  fields,
  header,
  /* PREPEND HERE */
};
export default charts;
